import { requests } from '../../../api/agent'

export default {
    getRegions: (params) => requests.getWithParams('/ReRegions/ListAllPaged', params),
    getRegionByName: (params) => requests.getWithParams('/ReRegions/getByName', params),
    createRegion: (params) => requests.post('/ReRegions/CreateRegion', params),
    deleteRegion: (params) => requests.post('/ReRegions/DeleteRegion', params),
    updateRegion: (params) => requests.post('/ReRegions/UpdateRegion', params),
    restoreRegion: (params) => requests.post('/ReRegions/RestoreRegion', params)
}